<div class="time-picker-dial">
  <div class="time-picker-dial__action">
    <ion-button fill="clear" class="time-picker-dial__action-btn time-picker-cancel-btn" (click)="close()">Cancel
    </ion-button>
    <p *ngIf="error" class="error">{{error}}</p>

    <ion-button [disabled]="(!!error)" class="bold time-picker-dial__action-btn time-picker-done-btn" fill="clear"
      (click)="done()">Done
    </ion-button>
  </div>
  <div *ngIf="!showKeypad" class="time-picker-with-keypad-icon">
    <div class="time-picker-dial__view">
      <div class="time-picker-dial__hour">
        <ion-buttons>
          <ion-button [disabled]="midnightSelected" (click)="addHour()" class="time-picker-dial__btn time-picker-dial__btn--1" slot="icon-only">
            <ion-icon name="chevron-up-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-text color="primary" class="time-picker-dial__value">
          {{getDisplayHour()}}
        </ion-text>
        <ion-buttons>
          <ion-button [disabled]="midnightSelected" (click)="reduceHour()" class="time-picker-dial__btn time-picker-dial__btn--1" slot="icon-only">
            <ion-icon name="chevron-down-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </div>
      <div class="time-picker-dial__seperator">
        <ion-text color="primary" class="time-picker-dial__value">
          :
        </ion-text>
      </div>
      <div class="time-picker-dial__minute">
        <ion-buttons>
          <ion-button [disabled]="midnightSelected" (click)="addMinute()" class="time-picker-dial__btn time-picker-dial__btn--1" slot="icon-only">
            <ion-icon name="chevron-up-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-text color="primary" class="time-picker-dial__value">
          {{getDisplayMinute()}}
        </ion-text>
        <ion-buttons>
          <ion-button [disabled]="midnightSelected" (click)="reduceMinute()" class="time-picker-dial__btn time-picker-dial__btn--1" slot="icon-only">
            <ion-icon name="chevron-down-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </div>
      <div class="time-picker-dial__meridiem">
        <ion-button [disabled]="midnightSelected" (click)="switchMeridiem()" class="time-picker-dial__btn time-picker-dial__btn--2" slot="icon-only">
          {{meridien}}
        </ion-button>
      </div>
    </div>
    <div class="time-picker-with-keypad-icon__actions">
        <ion-icon [ngClass]="{toggler: true, 'toggler__disabled': midnightSelected }" name="keypad-outline" (click)="toggle(null)"></ion-icon>
        <ion-item *ngIf="allowMidnight" lines="none">
          <ion-label>Midnight of the following day</ion-label>
          <ion-checkbox [checked]="midnightSelected" (ionChange)="handleMidnightChange($event)" color="tetratech" slot="start"></ion-checkbox>
        </ion-item>
    </div>



  </div>

  <div *ngIf="showKeypad">

    <div>
      <div class="flex-col">
        <div class="selected-time-view">

          <div class="selected-time" [ngClass]="{'no-value':  +minutes === 0 && +hours === 0}">
            {{hours}}
          </div>
          <div  style="color: black !important;">:</div>
          <div class="selected-time" [ngClass]="{'no-value': +minutes === 0 && +hours === 0 }">
            {{minutes}}
          </div>
          <div class="time-picker-dial__meridiem">
            <ion-button (click)="switchMeridiemKeyBoard()" class="time-picker-dial__btn time-picker-dial__btn--3"
              slot="icon-only">
              {{meridien}}
            </ion-button>
          </div>
        </div>
      </div>
      <div class="dial-pad-view">
        <div class="dial-pad">
          <div class="dial" *ngFor="let dial of dialPad" (click)="execMethod(dial)">

            <ion-text *ngIf="dial.number !== 'toggle'">{{dial.number}}</ion-text>
            <ion-icon *ngIf="dial.number === 'toggle'" name="keypad-outline"></ion-icon>

          </div>
        </div>
      </div>

    </div>
  </div>
</div>
